import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';
import { orderClient } from '@/lib/api/ts-rest';
import { getUserRole } from '@/lib/auth/token';

export const usePendingOrdersCount = () => {
  const userRole = getUserRole();

  return useQuery<number, Error>({
    queryKey: queryKeys.orders.pendingCount(),
    queryFn: async () => {
      const res = await orderClient.getPendingOrdersCount();
      if (res.status !== 200) throw new Error('Failed to load pending count');
      return res.body.count;
    },
    enabled: userRole === 'ADMIN',
    refetchInterval: 30000,
    staleTime: 30000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
